import { useService, useStore } from '@policoders/di';
import { FlashMessageService } from '@policoders/ds';
import HideConditional from '@shared/components/hide-conditional';
import Loading from '@shared/components/loading';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { AvaliacaoTmaStore } from '../avaliacao-tma/avaliacao-tma.store';
import patientService from '../patients/patient.service';
import { PatientStore } from '../patients/patient.store';

export const ReportAvaliacaoTma = () => {
  const { patientId, id } = useParams<any>() as { patientId: string; id: string };
  const flashMessage = useService<FlashMessageService>('FlashMessageService');
  const patientStore = useStore<PatientStore>('PatientStore');
  const storeTma = useStore<AvaliacaoTmaStore>('AvaliacaoTmaStore');

  useEffect(() => {
    if (!patientId) {
      return;
    }
    patientStore.getById(patientId);
  }, [patientId, patientStore]);

  useEffect(() => {
    if (patientStore.current?.id && !storeTma.current?.id) {
      storeTma.getById(id);
    }
  }, [id, patientStore, storeTma]);

  useEffect(() => {
    if (patientStore.errors && patientStore.errors.length > 0) {
      flashMessage.setMessage('error', JSON.stringify(patientStore.errors));
    }
  }, [flashMessage, patientStore.errors]);

  return (
    <>
      <Loading active={patientStore.loadind_current || storeTma.loadind_current} />
      <HideConditional condition={patientStore.loadind_current || storeTma.loadind_current}>
        <div className="card card-body mb-3 d-flex flex-row justify-content-between">
          <div>Nome: {patientStore.current?.name}</div>
          <div>Profissão: {patientStore.current?.occupation}</div>
          <div>Idade: {patientService.getAge(patientStore.current?.birth_date)}</div>
        </div>
        <div className="card card-body mb-3">
          <div>Queixa principal: {storeTma.current.queixa_principal}</div>
          <div>Quando iniciou: {storeTma.current.quando_iniciou}</div>
          <div>Evolução da dor: {storeTma.current.evolucao_da_dor}</div>
          <div>EVA: {storeTma.current.evaRange}</div>
          <div>O que impede de fazer: {storeTma.current.impedimentos}</div>
        </div>
      </HideConditional>
    </>
  );
};
